import React, { useState } from "react";

const importAll = (r) =>
  r.keys().map((key) => {
    const module = r(key);
    const src = module.default || module;
    const name = key.replace("./", "").split(".")[0].replace(/[-_]/g, " ");
    return { src, name };
  });

const images = importAll(
  require.context(
    "../../../assets/Ourmilestones/achievements",
    false,
    /\.(png|jpe?g|webp)$/
  )
);

const Achievements = () => {
  const [selectedImg, setSelectedImg] = useState(null);

  return (
    <div className="p-6 sm:p-10 bg-gradient-to-b from-white via-gray-50 to-gray-100 min-h-screen">
      {/* Page Title */}
      <div className="text-center mb-10">
        <h2 className="text-4xl sm:text-5xl font-extrabold text-gray-800 tracking-tight mb-3">
          🏆 Our Achievements
        </h2>
        <p className="text-gray-600 text-sm sm:text-base max-w-2xl mx-auto leading-relaxed">
          A proud showcase of our milestones, certifications, and recognitions
          that reflect our dedication to quality, innovation, and trust across
          industries.
        </p>
      </div>

      <div className="text-center mb-6">
        <h2 className="text-4xl sm:text-5xl font-extrabold text-gray-800 tracking-tight mb-3">
          JUST A BOLD HEART IS NEEDED TO BRING JUSTICE.
        </h2>
        <p className="text-gray-600 text-sm sm:text-base max-w-2xl mx-auto leading-relaxed">
         Shri Vikas Pandey HAS DONE THIS FOR THE PAST 6 YEARS FINALLY BRINGING
        RELIEF TOTHE CONSUMERS IN PARKING LOTS INSIDE MALLS
        </p>

       
      </div>
      {/* Gallery Grid */}
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-5 gap-6">
        {images.map((img, index) => (
          <div
            key={index}
            onClick={() => setSelectedImg(img.src)}
            className="group relative overflow-hidden rounded-2xl bg-white border border-gray-200 shadow-sm hover:shadow-xl transition-all duration-300 cursor-pointer"
          >
            <img
              src={img.src}
              alt={img.name}
              className="w-full h-40 sm:h-48 object-contain bg-white transition-transform duration-300 group-hover:scale-105 p-3"
            />

            {/* Overlay effect */}
            <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 flex flex-col items-center justify-end pb-3 transition-all duration-300">
              <p className="text-white text-sm font-medium text-center">
                {img.name}
              </p>
            </div>
          </div>
        ))}
      </div>

      {/* Modal / Lightbox */}
      {selectedImg && (
        <div
          className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-50 px-4"
          onClick={() => setSelectedImg(null)}
        >
          <div
            className="relative bg-white/10 backdrop-blur-md rounded-2xl p-4 shadow-2xl border border-white/20 max-w-4xl w-full"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={selectedImg}
              alt="Expanded"
              className="w-full max-h-[80vh] object-contain rounded-xl"
            />
            <button
              onClick={() => setSelectedImg(null)}
              className="absolute top-3 right-3 text-white bg-black/50 hover:bg-black/70 rounded-full p-2 transition"
            >
              ✕
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Achievements;
